import styled from 'styled-components';
import AskRemoveModal from './AskRemoveModal';
import { useState } from 'react';
import palette from '../../lib/styles/palette';

const ProjectActionButtonsBlock = styled.div`
    display: flex;
    justify-content: fled-end;
    margin-top: 1rem;
`;

const ActionButton = styled.button`
    padding: 0.25rem 0.5rem;
    bordrer-radius: 4px;
    color: ${palette.gray[6]};
    font-weight: bold;
    border: none;
    outline: none;
    font-size: 0.875rem;
    cursor: pointer;
    &:hover {
        background: ${palette.gray[1]};
        color: ${palette.cyan[7]};
    }
    & + & {
        margin-left: 0.25rem;
    }
`;

const ProjectActionButtons = ({ onEdit, onRemove, language }) => {
    const [modal, setModal] = useState(false);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const onRemoveClick = () => {
        setModal(true);
    };
    
    const onCancel = () => {
        setModal(false);
    };
    
    const onConfirm = () => {
        setModal(true);
        onRemove();
    };

    return (
        <>
            <ProjectActionButtonsBlock>
                <ActionButton onClick={onEdit}>
                    {isKR && '수정'}
                    {isJP && '修正'}
                    {isEN && 'Edit'}
                </ActionButton>
                <ActionButton onClick={onRemoveClick}>
                    {isKR && '삭제'}
                    {isJP && '削除'}
                    {isEN && 'Delete'}
                </ActionButton>
            </ProjectActionButtonsBlock>
            <AskRemoveModal visible={modal} onConfirm={onConfirm} onCancel={onCancel} />
        </>
    );
};

export default ProjectActionButtons;
